/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateAgelessOnboardingLocationRequest,
  DisplayAgelessOnboardingCreatedLocationResponse,
  DisplayAgelessOnboardingLocationsResponse,
  DisplayAgelessOnboardingNotificationPhoneNumberResponse,
  DisplayAgelessOnboardingProgressResponse,
  DisplayAgelessServiceAreaResponse,
  DisplayAgelessWaitlistEntryResponse,
  DisplayFreePrintsForLifeStatusResponse,
  ProblemDetails,
  SaveAgelessServiceAreaForPlatformRequest,
  SetAgelessOnboardingLocationAddressRequest,
  SetAgelessOnboardingLocationBookingUrlRequest,
  SetAgelessOnboardingLocationNameRequest,
  SetAgelessOnboardingLocationOperatingHoursRequest,
  SetAgelessOnboardingLocationPhoneNumberRequest,
  SetAgelessOnboardingNotificationPhoneNumberRequest,
  SetAgelessOnboardingStepCompletedRequest,
  SetDomainForPlatformRequest
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary Retrieve the free prints for life unlock status for a platform.
 */
export const getFreePrintsStatus = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayFreePrintsForLifeStatusResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/free-prints-status`, method: 'GET', signal
    },
      );
    }
  



export const getGetFreePrintsStatusQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/free-prints-status`
    ] as const;
    }

    
export const getGetFreePrintsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreePrintsStatusQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreePrintsStatus>>> = ({ signal }) => getFreePrintsStatus(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFreePrintsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getFreePrintsStatus>>>
export type GetFreePrintsStatusQueryError = ErrorType<unknown>


/**
 * @summary Retrieve the free prints for life unlock status for a platform.
 */

export function useGetFreePrintsStatus<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFreePrintsStatusQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Manually complete the free print challenge for a platform and unlock free prints.
Idempotent — the challenge-completed subscriber no-ops when the platform is already unlocked.
 */
export const unlockFreePrintsForPlatformForOnboarding = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/free-prints/unlock`, method: 'POST', signal
    },
      );
    }
  


export const getUnlockFreePrintsForPlatformForOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['unlockFreePrintsForPlatformForOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  unlockFreePrintsForPlatformForOnboarding(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UnlockFreePrintsForPlatformForOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>>
    
    export type UnlockFreePrintsForPlatformForOnboardingMutationError = ErrorType<unknown>

    /**
 * @summary Manually complete the free print challenge for a platform and unlock free prints.
Idempotent — the challenge-completed subscriber no-ops when the platform is already unlocked.
 */
export const useUnlockFreePrintsForPlatformForOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getUnlockFreePrintsForPlatformForOnboardingMutationOptions(options));
    }
    /**
 * @summary Retrieve the Ageless waitlist entry data for a platform during onboarding.
Returns null if not found.
 */
export const getWaitlistEntry = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessWaitlistEntryResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/waitlist`, method: 'GET', signal
    },
      );
    }
  



export const getGetWaitlistEntryQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/waitlist`
    ] as const;
    }

    
export const getGetWaitlistEntryQueryOptions = <TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWaitlistEntryQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWaitlistEntry>>> = ({ signal }) => getWaitlistEntry(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWaitlistEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getWaitlistEntry>>>
export type GetWaitlistEntryQueryError = ErrorType<unknown>


/**
 * @summary Retrieve the Ageless waitlist entry data for a platform during onboarding.
Returns null if not found.
 */

export function useGetWaitlistEntry<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWaitlistEntryQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieve the Ageless onboarding progress for a platform.
 */
export const getProgress = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessOnboardingProgressResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/progress`, method: 'GET', signal
    },
      );
    }
  



export const getGetProgressQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/progress`
    ] as const;
    }

    
export const getGetProgressQueryOptions = <TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgressQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgress>>> = ({ signal }) => getProgress(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getProgress>>>
export type GetProgressQueryError = ErrorType<unknown>


/**
 * @summary Retrieve the Ageless onboarding progress for a platform.
 */

export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProgressQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Mark an Ageless onboarding step as completed for a platform.
 */
export const setStepCompleted = (
    platformId: string,
    setAgelessOnboardingStepCompletedRequest: SetAgelessOnboardingStepCompletedRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/progress`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingStepCompletedRequest, signal
    },
      );
    }
  


export const getSetStepCompletedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStepCompleted>>, TError,{platformId: string;data: SetAgelessOnboardingStepCompletedRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setStepCompleted>>, TError,{platformId: string;data: SetAgelessOnboardingStepCompletedRequest}, TContext> => {

const mutationKey = ['setStepCompleted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setStepCompleted>>, {platformId: string;data: SetAgelessOnboardingStepCompletedRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setStepCompleted(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetStepCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof setStepCompleted>>>
    export type SetStepCompletedMutationBody = SetAgelessOnboardingStepCompletedRequest
    export type SetStepCompletedMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Mark an Ageless onboarding step as completed for a platform.
 */
export const useSetStepCompleted = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStepCompleted>>, TError,{platformId: string;data: SetAgelessOnboardingStepCompletedRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setStepCompleted>>,
        TError,
        {platformId: string;data: SetAgelessOnboardingStepCompletedRequest},
        TContext
      > => {
      return useMutation(getSetStepCompletedMutationOptions(options));
    }
    /**
 * @summary Set the domain for a platform during Ageless onboarding.
 */
export const setDomain = (
    platformId: string,
    setDomainForPlatformRequest: SetDomainForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/domain`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDomainForPlatformRequest, signal
    },
      );
    }
  


export const getSetDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDomain>>, TError,{platformId: string;data: SetDomainForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setDomain>>, TError,{platformId: string;data: SetDomainForPlatformRequest}, TContext> => {

const mutationKey = ['setDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDomain>>, {platformId: string;data: SetDomainForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setDomain(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetDomainMutationResult = NonNullable<Awaited<ReturnType<typeof setDomain>>>
    export type SetDomainMutationBody = SetDomainForPlatformRequest
    export type SetDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the domain for a platform during Ageless onboarding.
 */
export const useSetDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDomain>>, TError,{platformId: string;data: SetDomainForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setDomain>>,
        TError,
        {platformId: string;data: SetDomainForPlatformRequest},
        TContext
      > => {
      return useMutation(getSetDomainMutationOptions(options));
    }
    /**
 * @summary Retrieve the admin Ageless notification phone number for the current person.
 */
export const getNotificationPhoneNumber = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessOnboardingNotificationPhoneNumberResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/notification-phone-number`, method: 'GET', signal
    },
      );
    }
  



export const getGetNotificationPhoneNumberQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/notification-phone-number`
    ] as const;
    }

    
export const getGetNotificationPhoneNumberQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationPhoneNumberQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPhoneNumber>>> = ({ signal }) => getNotificationPhoneNumber(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationPhoneNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationPhoneNumber>>>
export type GetNotificationPhoneNumberQueryError = ErrorType<ProblemDetails>


/**
 * @summary Retrieve the admin Ageless notification phone number for the current person.
 */

export function useGetNotificationPhoneNumber<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationPhoneNumberQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Set the admin Ageless notification phone number for the current person.
 */
export const setNotificationPhoneNumber = (
    platformId: string,
    setAgelessOnboardingNotificationPhoneNumberRequest: SetAgelessOnboardingNotificationPhoneNumberRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/notification-phone-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingNotificationPhoneNumberRequest, signal
    },
      );
    }
  


export const getSetNotificationPhoneNumberMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, TError,{platformId: string;data: SetAgelessOnboardingNotificationPhoneNumberRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, TError,{platformId: string;data: SetAgelessOnboardingNotificationPhoneNumberRequest}, TContext> => {

const mutationKey = ['setNotificationPhoneNumber'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, {platformId: string;data: SetAgelessOnboardingNotificationPhoneNumberRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setNotificationPhoneNumber(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetNotificationPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof setNotificationPhoneNumber>>>
    export type SetNotificationPhoneNumberMutationBody = SetAgelessOnboardingNotificationPhoneNumberRequest
    export type SetNotificationPhoneNumberMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the admin Ageless notification phone number for the current person.
 */
export const useSetNotificationPhoneNumber = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, TError,{platformId: string;data: SetAgelessOnboardingNotificationPhoneNumberRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setNotificationPhoneNumber>>,
        TError,
        {platformId: string;data: SetAgelessOnboardingNotificationPhoneNumberRequest},
        TContext
      > => {
      return useMutation(getSetNotificationPhoneNumberMutationOptions(options));
    }
    /**
 * @summary Retrieve all locations for a platform during onboarding.
 */
export const getLocations = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessOnboardingLocationsResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations`, method: 'GET', signal
    },
      );
    }
  



export const getGetLocationsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/locations`
    ] as const;
    }

    
export const getGetLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({ signal }) => getLocations(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocations>>>
export type GetLocationsQueryError = ErrorType<unknown>


/**
 * @summary Retrieve all locations for a platform during onboarding.
 */

export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLocationsQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Create a new location for a platform during onboarding.
 */
export const createLocation = (
    platformId: string,
    createAgelessOnboardingLocationRequest: CreateAgelessOnboardingLocationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessOnboardingCreatedLocationResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAgelessOnboardingLocationRequest, signal
    },
      );
    }
  


export const getCreateLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{platformId: string;data: CreateAgelessOnboardingLocationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{platformId: string;data: CreateAgelessOnboardingLocationRequest}, TContext> => {

const mutationKey = ['createLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, {platformId: string;data: CreateAgelessOnboardingLocationRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  createLocation(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = CreateAgelessOnboardingLocationRequest
    export type CreateLocationMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Create a new location for a platform during onboarding.
 */
export const useCreateLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{platformId: string;data: CreateAgelessOnboardingLocationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        {platformId: string;data: CreateAgelessOnboardingLocationRequest},
        TContext
      > => {
      return useMutation(getCreateLocationMutationOptions(options));
    }
    /**
 * @summary Set the name for a platform location during onboarding.
 */
export const setLocationName = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationNameRequest: SetAgelessOnboardingLocationNameRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationNameRequest, signal
    },
      );
    }
  


export const getSetLocationNameMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationName>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationNameRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationName>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationNameRequest}, TContext> => {

const mutationKey = ['setLocationName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationName>>, {platformId: string;locationId: string;data: SetAgelessOnboardingLocationNameRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationName(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetLocationNameMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationName>>>
    export type SetLocationNameMutationBody = SetAgelessOnboardingLocationNameRequest
    export type SetLocationNameMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the name for a platform location during onboarding.
 */
export const useSetLocationName = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationName>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationNameRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLocationName>>,
        TError,
        {platformId: string;locationId: string;data: SetAgelessOnboardingLocationNameRequest},
        TContext
      > => {
      return useMutation(getSetLocationNameMutationOptions(options));
    }
    /**
 * @summary Set the physical address for a platform location during onboarding.
 */
export const setLocationAddress = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationAddressRequest: SetAgelessOnboardingLocationAddressRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/address`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationAddressRequest, signal
    },
      );
    }
  


export const getSetLocationAddressMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationAddress>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationAddressRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationAddress>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationAddressRequest}, TContext> => {

const mutationKey = ['setLocationAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationAddress>>, {platformId: string;locationId: string;data: SetAgelessOnboardingLocationAddressRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationAddress(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetLocationAddressMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationAddress>>>
    export type SetLocationAddressMutationBody = SetAgelessOnboardingLocationAddressRequest
    export type SetLocationAddressMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the physical address for a platform location during onboarding.
 */
export const useSetLocationAddress = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationAddress>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationAddressRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLocationAddress>>,
        TError,
        {platformId: string;locationId: string;data: SetAgelessOnboardingLocationAddressRequest},
        TContext
      > => {
      return useMutation(getSetLocationAddressMutationOptions(options));
    }
    /**
 * @summary Set the phone number for a platform location during onboarding.
 */
export const setLocationPhoneNumber = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationPhoneNumberRequest: SetAgelessOnboardingLocationPhoneNumberRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/phone-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationPhoneNumberRequest, signal
    },
      );
    }
  


export const getSetLocationPhoneNumberMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationPhoneNumber>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationPhoneNumberRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationPhoneNumber>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationPhoneNumberRequest}, TContext> => {

const mutationKey = ['setLocationPhoneNumber'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationPhoneNumber>>, {platformId: string;locationId: string;data: SetAgelessOnboardingLocationPhoneNumberRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationPhoneNumber(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetLocationPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationPhoneNumber>>>
    export type SetLocationPhoneNumberMutationBody = SetAgelessOnboardingLocationPhoneNumberRequest
    export type SetLocationPhoneNumberMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the phone number for a platform location during onboarding.
 */
export const useSetLocationPhoneNumber = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationPhoneNumber>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationPhoneNumberRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLocationPhoneNumber>>,
        TError,
        {platformId: string;locationId: string;data: SetAgelessOnboardingLocationPhoneNumberRequest},
        TContext
      > => {
      return useMutation(getSetLocationPhoneNumberMutationOptions(options));
    }
    /**
 * @summary Set the booking URL for a platform location during onboarding.
 */
export const setLocationBookingUrl = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationBookingUrlRequest: SetAgelessOnboardingLocationBookingUrlRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/booking-url`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationBookingUrlRequest, signal
    },
      );
    }
  


export const getSetLocationBookingUrlMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationBookingUrl>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationBookingUrlRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationBookingUrl>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationBookingUrlRequest}, TContext> => {

const mutationKey = ['setLocationBookingUrl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationBookingUrl>>, {platformId: string;locationId: string;data: SetAgelessOnboardingLocationBookingUrlRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationBookingUrl(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetLocationBookingUrlMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationBookingUrl>>>
    export type SetLocationBookingUrlMutationBody = SetAgelessOnboardingLocationBookingUrlRequest
    export type SetLocationBookingUrlMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the booking URL for a platform location during onboarding.
 */
export const useSetLocationBookingUrl = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationBookingUrl>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationBookingUrlRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLocationBookingUrl>>,
        TError,
        {platformId: string;locationId: string;data: SetAgelessOnboardingLocationBookingUrlRequest},
        TContext
      > => {
      return useMutation(getSetLocationBookingUrlMutationOptions(options));
    }
    /**
 * @summary Set operating hours for a platform location during onboarding.
 */
export const setLocationOperatingHours = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationOperatingHoursRequest: SetAgelessOnboardingLocationOperatingHoursRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/operating-hours`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationOperatingHoursRequest, signal
    },
      );
    }
  


export const getSetLocationOperatingHoursMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationOperatingHours>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationOperatingHoursRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationOperatingHours>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationOperatingHoursRequest}, TContext> => {

const mutationKey = ['setLocationOperatingHours'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationOperatingHours>>, {platformId: string;locationId: string;data: SetAgelessOnboardingLocationOperatingHoursRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationOperatingHours(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetLocationOperatingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationOperatingHours>>>
    export type SetLocationOperatingHoursMutationBody = SetAgelessOnboardingLocationOperatingHoursRequest
    export type SetLocationOperatingHoursMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set operating hours for a platform location during onboarding.
 */
export const useSetLocationOperatingHours = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationOperatingHours>>, TError,{platformId: string;locationId: string;data: SetAgelessOnboardingLocationOperatingHoursRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLocationOperatingHours>>,
        TError,
        {platformId: string;locationId: string;data: SetAgelessOnboardingLocationOperatingHoursRequest},
        TContext
      > => {
      return useMutation(getSetLocationOperatingHoursMutationOptions(options));
    }
    /**
 * @summary Retrieve the Ageless service area configuration for a platform.
 */
export const getServiceArea = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessServiceAreaResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/service-area`, method: 'GET', signal
    },
      );
    }
  



export const getGetServiceAreaQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/service-area`
    ] as const;
    }

    
export const getGetServiceAreaQueryOptions = <TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAreaQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceArea>>> = ({ signal }) => getServiceArea(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData> & { queryKey: QueryKey }
}

export type GetServiceAreaQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceArea>>>
export type GetServiceAreaQueryError = ErrorType<unknown>


/**
 * @summary Retrieve the Ageless service area configuration for a platform.
 */

export function useGetServiceArea<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetServiceAreaQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Define or update the Ageless service area for a platform.
 */
export const saveServiceArea = (
    platformId: string,
    saveAgelessServiceAreaForPlatformRequest: SaveAgelessServiceAreaForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/service-area`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveAgelessServiceAreaForPlatformRequest, signal
    },
      );
    }
  


export const getSaveServiceAreaMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveServiceArea>>, TError,{platformId: string;data: SaveAgelessServiceAreaForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveServiceArea>>, TError,{platformId: string;data: SaveAgelessServiceAreaForPlatformRequest}, TContext> => {

const mutationKey = ['saveServiceArea'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveServiceArea>>, {platformId: string;data: SaveAgelessServiceAreaForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  saveServiceArea(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SaveServiceAreaMutationResult = NonNullable<Awaited<ReturnType<typeof saveServiceArea>>>
    export type SaveServiceAreaMutationBody = SaveAgelessServiceAreaForPlatformRequest
    export type SaveServiceAreaMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Define or update the Ageless service area for a platform.
 */
export const useSaveServiceArea = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveServiceArea>>, TError,{platformId: string;data: SaveAgelessServiceAreaForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveServiceArea>>,
        TError,
        {platformId: string;data: SaveAgelessServiceAreaForPlatformRequest},
        TContext
      > => {
      return useMutation(getSaveServiceAreaMutationOptions(options));
    }
    